import NiceSelect from 'nice-select2/src/js/nice-select2';

export default class Selects {
    constructor() {
        this.init();
    }

    init() {

        document.querySelectorAll('.form-select').forEach((selectElement) => {
            new NiceSelect(selectElement, { searchable: false });
        });

    }
}